module.exports = __webpack_public_path__ + "c4d558cb708ec00e0ade7b1c30e1647c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/cpeel-c-logo.png
 ** module id = 201
 ** module chunks = 0
 **/